import { Box, Card, Tooltip, Typography, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'

const icons = {
  Receba: '/static/images/logo/receba.png',
  Capture: '/static/images/logo/capture.png',
  Modere: '/static/images/logo/modere.png',
  Apresente: '/static/images/logo/apresente.png',
  Youon: '/static/images/logo/logoyouon.svg',
}

const CardImg = styled(Card)(
  ({ theme }) => `
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    border: 1px solid ${theme.colors.alpha.black[10]};
    transition: ${theme.transitions.create(['border'])};

    &:hover {
      border-color: ${theme.colors.primary.main};
    }
`
)

// dark=true → texto branco (portal sidebar escuro)
// dark=false → texto padrão do tema (login, fundo claro)
// showLogo=false → oculta logo (quando sidebar já mostra outra logo no header)
export default function PortalPromo({ dark = false, logoWidth = 200, showLogo = true }) {
  const { t } = useTranslation()
  const textColor = dark ? 'rgba(255,255,255,0.9)' : undefined
  const subtextColor = dark ? 'rgba(255,255,255,0.6)' : undefined

  return (
    <Box display="flex" flexDirection="column">
      {showLogo && <img width={logoWidth} alt="Youon" src={icons['Youon']} />}

      <Box mt={4}>
        <Typography
          variant="h1"
          sx={{ mb: 5, fontSize: '1.6rem', color: textColor }}
        >
          {t('Portal Youon')}
        </Typography>

        {/* Floating icons */}
        <Box sx={{ position: 'relative', width: 240, height: 110 }}>
          <Tooltip arrow placement="top" title="Receba">
            <CardImg sx={{ width: 64, height: 64, left: -12, top: -30 }}>
              <img width={40} alt="Receba" src={icons['Receba']} />
            </CardImg>
          </Tooltip>
          <Tooltip arrow placement="top" title="Capture">
            <CardImg sx={{ width: 72, height: 72, left: 58, top: 4 }}>
              <img width={52} alt="Capture" src={icons['Capture']} />
            </CardImg>
          </Tooltip>
          <Tooltip arrow placement="top" title="Modere">
            <CardImg sx={{ width: 80, height: 80, left: 138, top: -24 }}>
              <img width={56} alt="Modere" src={icons['Modere']} />
            </CardImg>
          </Tooltip>
          <Tooltip arrow placement="top" title="Apresente">
            <CardImg sx={{ width: 72, height: 72, left: 200, top: 10 }}>
              <img width={52} alt="Apresente" src={icons['Apresente']} />
            </CardImg>
          </Tooltip>
        </Box>

        <Typography variant="h3" sx={{ mt: 3, mb: 2, color: textColor }}>
          {t('O jeito mais fácil de interagir com a sua audiência!')}
        </Typography>

        <Typography variant="subtitle1" sx={{ color: subtextColor }}>
          {t(
            'Com o Youon, sua equipe poderá publicar de forma extremamente rápida mensagens, imagens e vídeos recebidos das mídias sociais diretamente no seu estúdio de TV. Isso tudo de forma fácil e totalmente segura'
          )}
          .
        </Typography>
      </Box>
    </Box>
  )
}
